export function AppLoading() {
  return (
    <div className="flex h-screen flex-col items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-7 animate-in-page">
        {/* Logo */}
        <img
          src="/logo-with-text-blue.png"
          alt="C2 Vault"
          width={140}
          height={28}
          className="h-8 w-auto opacity-90"
        />

        {/* Indeterminate sliding bar */}
        <div className="relative h-[2px] w-32 overflow-hidden rounded-full bg-primary/15">
          <div className="animate-loading-bar absolute inset-y-0 left-0 w-1/2 rounded-full bg-primary/70" />
        </div>
      </div>
    </div>
  );
}
